import React, { useState } from 'react';
import PullRunsCancelModal from '../PullRunsCancelModal';
import pullRunsService from '../../shared/services/pullRunsService';
import type { PullRun } from '../../shared/services/pullRunsService';

export interface PullRunsCancelButtonProps {
  pullRun: PullRun;
  onCancelSuccess?: (pullRunId: number) => void;
  onCancelError?: (pullRunId: number, error: string) => void;
}

export const PullRunsCancelButton: React.FC<PullRunsCancelButtonProps> = ({
  pullRun,
  onCancelSuccess,
  onCancelError
}) => {
  const [showModal, setShowModal] = useState(false);

  // Проверяем, можно ли отменить задачу
  const canCancel = pullRunsService.canBeCancelled(pullRun);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // Если задача не может быть отменена, не показываем кнопку
  if (!canCancel) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="btn btn-small btn-delete"
        onClick={() => setShowModal(true)}
        title="Отменить задачу"
      >
        ✕
      </button>

      <PullRunsCancelModal
        isOpen={showModal}
        pullRun={pullRun}
        onClose={handleCloseModal}
        onCancelSuccess={onCancelSuccess}
        onCancelError={onCancelError}
      />
    </>
  );
};

export default PullRunsCancelButton;
